import application_settings from '../applicationSettings';
import LocalStorage from '../local_data';
import Event from './Event';

class VerifyOtp extends Event {
    eventName = 'oms_verifyOtp';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Validate Discount Code
     * 
     * @param {string} data.discount_code -  discount code
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let otp = data.otp;
        let otpReqId = data.otp_request_id;

        if (clientId && otp && otpReqId) {

            // request data
            data.endPoint = application_settings.endPoints.verifyOtp;
            data.method = 'POST';
            data.multi_call_key = (data.multi_call_key) ? data.multi_call_key : 'verify_otp';
            data.data = {
                client_id: clientId,
                otp: otp,
                otp_request_id: otpReqId,
                type: data.type
            };
        
            // send request
            this.sendRequest(data, function (response) {
              if (response) {

                //format response data
                let data = thisObj.formatResponseData(response);

                if (data.success && data.data.token.access_token) {
                    let userDetails = new LocalStorage.UserDetails(clientId);
                    userDetails.setData(response);

                    window.ajaxAuthRequest = null;
                }

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
              }
            });

        } else {
            //fire error event
            thisObj.onErrorEvent({ "message": "client_id && otp && otp_request_id are required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default VerifyOtp;